import { Skeleton } from '../../Skeleton'

import * as styles from './ProfileDocumentsWidgetContentImagesSkeleton.module.css'

function ProfileDocumentsWidgetContentImagesSkeleton({
  className = styles.ProfileDocumentsWidgetContentImagesSkeleton,
}) {
  return (
    <div className={className}>
      <Skeleton className={styles.title} />
      <div className={styles.images}>
        <Skeleton className={styles.image} />
        <Skeleton className={styles.image} />
      </div>
    </div>
  )
}

export default ProfileDocumentsWidgetContentImagesSkeleton
